export default __webpack_public_path__ + "static/media/marquise-reversed.d0e9132d.svg";